module.exports = __webpack_public_path__ + "static/docussaurus-06556b4ca383c586b2286181b5e31fc2.png";